// import React, {useEffect} from 'react';
// import 'react-perfect-scrollbar/dist/css/styles.css';
// import PerfectScrollbar from 'react-perfect-scrollbar';
// import {useLocation} from 'react-router-dom';
//
// const AppScrollbar = ({children, scrollToTop, className, ...others}) => {
//   let _scrollBarRef = null;
//   const {pathname} = useLocation();
//
//   useEffect(() => {
//     if (scrollToTop && _scrollBarRef) {
//       _scrollBarRef._container.scrollTop = 0;
//     }
//   }, [_scrollBarRef, scrollToTop, pathname]);
//
//   return (
//     <PerfectScrollbar
//       ref={(ref) => {
//         _scrollBarRef = ref;
//       }}
//       {...others}
//       className={className}>
//       {children}
//     </PerfectScrollbar>
//   );
// };
//
// export default AppScrollbar;
//
// AppScrollbar.defaultProps = {
//   className: '',
//   scrollToTop: true,
// };
//
// AppScrollbar.propTypes = {
//   children: PropTypes.node.isRequired,
//   scrollToTop: PropTypes.bool,
//   className: PropTypes.string,
// };
import React, { ReactNode, useEffect, useRef, useCallback } from 'react';
import SimpleBarReact from 'simplebar-react';
import SimpleBarCore from 'simplebar-core';
import 'simplebar-react/dist/simplebar.min.css';
import styled from 'styled-components';

export const StyledScrollbar = styled(SimpleBarReact)`
  position: relative;
  width: 100%;
  height: 100%;

  & .simplebar-offset,
  & .simplebar-content-wrapper,
  & .simplebar-content {
    height: 100%;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
  }

  /* Track - white rounded background, fixed 6px regardless of zoom */
  & .simplebar-track.simplebar-vertical {
    width: 6px;
    min-width: 6px;
    max-width: 6px;
    right: 2px;
    background: #ffffff;
    border-radius: 3px;
  }

  /* Scrollbar thumb container */
  & .simplebar-track.simplebar-vertical .simplebar-scrollbar {
    width: 6px;
    min-width: 6px;
    max-width: 6px;
    right: 0;
  }

  /* Thumb with dynamic glow dot - --glow-pos set by JS */
  & .simplebar-scrollbar::before {
    background:
      radial-gradient(
        circle 2px at 50% calc(var(--glow-pos, 85) * 1%),
        white 0%,
        transparent 100%
      ),
      radial-gradient(
        circle 4px at 50% calc(var(--glow-pos, 85) * 1%),
        #99ead6 0%,
        transparent 100%
      ),
      radial-gradient(
        circle farthest-side at 50% calc(var(--glow-pos, 85) * 1%),
        #33d5ad 0%,
        #00795b 100%
      );
    border-radius: 3px;
    opacity: 0;
    transition: opacity 0.3s ease;
    left: 0;
    right: 0;
  }

  & .simplebar-scrollbar.simplebar-visible::before {
    opacity: 1;
  }

  &:hover .simplebar-scrollbar::before {
    opacity: 1;
  }
`;

// eslint-disable-next-line no-unused-vars
type AppScrollbarProps = {
  children: ReactNode;
  className?: string;
  scrollToTop?: boolean;

  [x: string]: any;
};

const AppScrollbar: React.FC<AppScrollbarProps> = ({
  children,
  className,
  scrollToTop,
  ...others
}) => {
  const simpleBarRef = useRef<SimpleBarCore | null>(null);

  const handleScroll = useCallback(() => {
    const instance = simpleBarRef.current;
    if (!instance) return;

    const scrollEl = instance.getScrollElement();
    if (!scrollEl) return;

    const { scrollTop, scrollHeight, clientHeight } = scrollEl;
    const maxScroll = scrollHeight - clientHeight;
    const percent = maxScroll > 0 ? 1 + (scrollTop / maxScroll) * 98 : 50;

    const thumb = instance.el?.querySelector(
      '.simplebar-track.simplebar-vertical .simplebar-scrollbar',
    ) as HTMLElement | null;

    if (thumb) {
      thumb.style.setProperty('--glow-pos', String(percent));
    }
  }, []);

  useEffect(() => {
    const instance = simpleBarRef.current;
    if (!instance) return;

    const scrollEl = instance.getScrollElement();
    if (!scrollEl) return;

    scrollEl.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      scrollEl.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return (
    <StyledScrollbar ref={simpleBarRef} autoHide {...others} className={className}>
      {children}
    </StyledScrollbar>
  );
};

export default AppScrollbar;
